import { combineURLs } from './url';

export const resolveImageSrc = (src: string) => {
  if (typeof src !== 'string') return;
  if (/^https?:\/\//i.test(src)) return src; // absolute URL
  if (window.__pollsImageDomain) return combineURLs(window.__pollsImageDomain, src); // known prefix
  return src;
};
